import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { LevelResult } from '../types/quiz';
import { brevoForms } from '../data/brevoForms';
import { BrevoResultForm } from './BrevoResultForm';
interface ResultPanelProps {
  result: LevelResult;
  webinarUrl: string;
  onRestart: () => void;
}
export function ResultPanel({
  result,
  webinarUrl,
  onRestart
}: ResultPanelProps) {
  const formConfig = brevoForms[result.key];
  return <div data-id="element-117" data-mp="mjttln6643d2">
      <p className="font-sans text-sm font-medium tracking-wide text-dorado-deep" data-id="element-118" data-mp="mk3p1q9zf2q5">
        Tu nivel dominante es
      </p>

      <h2 className="mt-3 font-serif text-4xl leading-tight text-violeta sm:text-5xl" data-id="element-119" data-mp="wijfdr16q7yl">
        {result.name}
      </h2>
      <p className="mt-2 font-sans text-sm text-noche/55" data-id="element-120" data-mp="10kmt6mbbton1">{result.stage}</p>

      <p className="mt-8 font-serif text-2xl leading-snug text-noche" data-id="element-121" data-mp="2y9w5vb2eodb4">{result.headline}</p>

      <p className="mt-5 font-sans text-base leading-relaxed text-noche/75" data-id="element-122" data-mp="2yc8wecm8bvzs">{result.description}</p>

      <div className="mt-10 border-l-2 border-dorado pl-6" data-id="element-123" data-mp="32daxz03mck4x">
        <h3 className="font-sans text-sm font-semibold uppercase tracking-wide text-noche/60" data-id="element-124" data-mp="gcrifouvn0i9">
          Cómo se ve este nivel en tu día a día
        </h3>
        <ul className="mt-4 space-y-2.5" data-id="element-125" data-mp="6lwu8ey2lqu6">
          {result.signals.map(signal => <li key={signal} className="font-sans text-base leading-relaxed text-noche/80" data-id="element-126" data-mp="1n3iaqyfm7w4">
              {signal}
            </li>)}
        </ul>
      </div>

      <div className="mt-12" data-id="element-127" data-mp="za2gx78oppwn">
        {formConfig ? <BrevoResultForm config={formConfig} data-id="element-128" data-mp="ubhfj4hp506m" /> : <div className="rounded-sm border border-dashed border-noche/25 bg-white/60 px-6 py-8 text-center" data-id="element-129" data-mp="u9wm5i74bnac">
            <p className="font-serif text-xl text-violeta" data-id="element-130" data-mp="kdl6ci8bkfb5">
              Formulario de {result.tag} pendiente de conectar
            </p>
            <p className="mx-auto mt-3 max-w-md font-sans text-sm leading-relaxed text-noche/60" data-id="element-131" data-mp="3a3y6r1ehfpqo">
              Envíame el código de Brevo para este nivel y lo inserto aquí, igual que en el nivel de
              Culpa.
            </p>
          </div>}
      </div>

      <div className="mt-12 bg-violeta px-6 py-8 text-hueso sm:px-8" data-id="element-132" data-mp="216gl36t5k05z">
        <h3 className="font-serif text-xl text-dorado" data-id="element-133" data-mp="213m1fhhyqjdm">Tu primer paso para subir de nivel</h3>
        <p className="mt-3 font-sans text-base leading-relaxed text-hueso/85" data-id="element-134" data-mp="1n89u8ammf0ft">{result.firstStep}</p>
      </div>

      <p className="mt-10 font-sans text-base leading-relaxed text-noche/75" data-id="element-135" data-mp="1dgdvqygmh8b2">
        Te acabamos de enviar tu resultado completo a tu correo, junto con el primer paso para
        empezar a subir de nivel hoy mismo.
      </p>

      <div className="mt-8 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-136" data-mp="14g7jffwnuedh">
        <a href={webinarUrl} className="group inline-flex items-center gap-2 rounded-sm bg-dorado px-8 py-4 font-sans text-base font-semibold text-noche transition-colors duration-150 ease-out hover:bg-dorado-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-violeta focus-visible:ring-offset-2 focus-visible:ring-offset-hueso" data-id="element-137" data-mp="19e94g6dncnrl">
          Quiero mi plan personalizado
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-138" data-mp="btzh90sd9i26" />
        </a>
        <button type="button" onClick={onRestart} className="font-sans text-sm text-noche/55 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-violeta focus:outline-none focus-visible:ring-2 focus-visible:ring-violeta" data-id="element-139" data-mp="ku5oi4xh1lsw">
          Volver a hacer el test
        </button>
      </div>
    </div>;
}